export default __webpack_public_path__ + "static/media/m_five.7bfee03d.png";